'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { SEARCH_RESULTS_PATH_REGEX } from '@provider-directory/models/navigation.model';
import { getCompleteSearchParams } from '@provider-directory/types/search.model';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const NavigationEvents = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const analytics = useAnalytics();

  const analyticsRef = useRef(analytics);
  analyticsRef.current = analytics;

  // Only the most recent key, so returning to an earlier page still reports it.
  const lastPageKeyRef = useRef<string | null>(null);

  const { isReady } = analytics;

  useEffect(() => {
    if (!isReady) {
      return;
    }

    const pageKey = `${pathname}?${searchParams.toString()}`;
    if (lastPageKeyRef.current === pageKey) {
      return;
    }
    lastPageKeyRef.current = pageKey;

    const isSearchResultsPage = SEARCH_RESULTS_PATH_REGEX.exec(pathname);
    if (isSearchResultsPage || pathname.startsWith('/providers/find')) {
      const searchResultsParams = Object.entries({
        ...getCompleteSearchParams(searchParams),
        specialty: isSearchResultsPage?.[1]
          ? decodeURIComponent(isSearchResultsPage[1])
          : undefined,
      }).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [`search.${key}`]: value,
        }),
        {},
      );
      analyticsRef.current.page(searchResultsParams);
    } else if (!pathname.includes('/appointment/')) {
      analyticsRef.current.page();
    }
  }, [pathname, searchParams, isReady]);

  return null;
};
